import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import { FormProvider, useForm } from 'react-hook-form'
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from '@mui/material'
import SubmitButton from '../../commonUIComponents/SubmitButton'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import userService from '../../../services/userService'
import VerifyPasswordModal from './VerifyPasswordModal'

const UpdatePhoneNumberModal = ({ open, onClose }) => {
  const [openUpdatePhoneNumberModal, setOpenUpdatePhoneNumberModal] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods

  const submitHandler = values => {
    return userService.updateUserById({ phoneNumber: values.phoneNumber })
      .then(res => {
        onCloseHandler()
        enqueueSnackbar('Successfully updated your phone number !', { variant: 'success' })
        navigate('/settings')
      })
      .catch(err => enqueueSnackbar(err.response?.data?.message, { variant: 'warning' }))
  }

  const onCloseHandler = () => {
    onClose()
    setOpenUpdatePhoneNumberModal(false)
  }

  const onNextModalHandler = () => {
    setOpenUpdatePhoneNumberModal(true)
  }

  const UpdatePhoneNumberModal = () => {
    return (
      <>
        {openUpdatePhoneNumberModal
          ? (
            <Dialog
              open={openUpdatePhoneNumberModal}
              onClose={onCloseHandler}
            >
              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(submitHandler)}>
                  <Grid container>
                    <Grid item xs={12}>
                      <DialogTitle>Phone Number</DialogTitle>
                    </Grid>
                    <Grid item xs={12}>
                      <DialogContent sx={{ mt: '-1rem' }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>

                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="subtitle2" color="textSecondary">
                              Reddit will use your phone number for account verification and to personalize your ads and experience. SMS fees may apply.
                            </Typography>
                          </Grid>
                        </Grid>
                      </DialogContent>
                    </Grid>
                  </Grid>
                  <IconButton
                    aria-label="close"
                    onClick={onCloseHandler}
                    sx={(theme) => ({
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: theme.palette.grey[500]
                    })}
                  >
                    <CloseIcon/>
                  </IconButton>
                  <DialogActions>
                    <SubmitButton buttonLabel="Continue" textAlign="right"/>
                  </DialogActions>
                </form>
              </FormProvider>
            </Dialog>
            )
          : undefined
        }
      </>
    )
  }

  return (
    <>
      <VerifyPasswordModal methods={methods} open={open} onClose={onCloseHandler} onNext={onNextModalHandler}/>
      <UpdatePhoneNumberModal/>
    </>
  )
}

export default UpdatePhoneNumberModal
